import { Box, Flex, Heading, Container, AspectRatio, Skeleton } from '@chakra-ui/react';

export const NoTicketSkeleton = () => {
  return (
    <Container>
      <Flex alignItems={{ lg: 'center' }} justifyContent={{ lg: 'center' }} pt={24}>
        <Flex flexDirection={['column', null, null, 'row']} minW="full" minH={{ lg: '430px' }} py={[5, null, 7, 0]}>
          <Box w={{ base: 'full', lg: '50%' }} mr={{ lg: 6 }}>
            <AspectRatio h={{ base: '160px', sm: '330px', lg: '430px' }} ratio={4 / 3}>
              <Skeleton height="100%" />
            </AspectRatio>
          </Box>
          <Box w={['full', null, null, '50%']} ml={{ lg: 6 }} py={[5, null, 0]}>
            <Heading fontSize={['1.5rem', null, null, '2rem']} lineHeight={[8, null, null, 9]} mb={[6, null, null, 10]}>
              <Skeleton height="50%" />
            </Heading>
            <Skeleton height="50%" />
          </Box>
        </Flex>
      </Flex>
    </Container>
  );
};
